// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 368) return "static/chunks/020cf71b-ed67e190743c9287.js";
	if (chunkId === 685) return "static/chunks/685-faea1a07cd517370.js";
	if (chunkId === 752) return "static/chunks/752-732ae79d067545d9.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"43d51216a8c400fe","205":"2e90144ef4045da8","319":"0cbc2894a3f1b950","340":"5cfd31da617c23c0","367":"5cd23c46ef616fc4","639":"e7b660adfa99260e","748":"38401532a829862f"}[chunkId] + ".js";
};